import { useEffect } from 'react';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getHelpNodePath } from '@ergeon/help-components';

const NodeKeyRedirect = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const requestedNodeKey = searchParams.get('node_key');

  useEffect(function openTheRequestedNode() {
    if (!requestedNodeKey) {
      return;
    }
    const nodePath = getHelpNodePath(requestedNodeKey);
    if (pathname !== nodePath) {
      navigate(nodePath, { replace: true });
    }
  }, [navigate, pathname, requestedNodeKey]);

  return null;
};

export default NodeKeyRedirect;
